const BOTTOM_LAYER = 1;
const MIDDLE_LAYER = 2;
const TOP_LAYER = 3;

export const SUBMITTED_LAYER_STYLE = {
  strokeColor: 'red',
  strokeOpacity: 0.8,
  strokeWeight: 1,
  fillColor: 'red',
  fillOpacity: 0.4,
  zIndex: TOP_LAYER,
};

export const PROCESSED_LAYER_STYLE = {
  strokeColor: '#007EFF',
  strokeOpacity: 0.8,
  strokeWeight: 1,
  fillColor: '#007EFF',
  fillOpacity: 0.4,
  zIndex: MIDDLE_LAYER,
};

export const BOUNDING_BOX_LAYER_STYLE = {
  strokeColor: 'black',
  strokeOpacity: 1,
  strokeWeight: 1,
  fillColor: 'black',
  fillOpacity: 0.1,
  zIndex: BOTTOM_LAYER,
};
